export type MembershipInput<T extends string> = {
  register: T;
  placeholder: string;
  label?: string;
  size?: number;
  disabled?: boolean;
  type?: "text" | "password";
};

export type MembershipFieldSet<T extends string> = {
  legend: string;
  inputs: MembershipInput<T>[];
};

export type PersonalInformationFormFields = {
  email: string;
  password: string;
  confirmPassword: string;
  phoneNumber: string;
  address1: string;
  address2: string;
  city: string;
  postalCode: string;
  industry: string;
  jobTitle: string;
  companyName: string;
  professionalEmail: string;
  town: string;
};

export type PaymentFormFields = {
  cardNumber: string;
};

export type SponsorshipFormFields = {
  firstname: string;
  lastname: string;
  email?: string;
};

export type SponsorshipEmailFields = {
  firstname: string;
  code: string;
  email: string;
};

export type SponsorshipFormResponse = SponsorshipFormFields & { code: string };

export enum AccountSectionEnum {
  "PROGRAMMATION" = "Programmation",
  "AGENDA" = "Agenda",
  "MEMBERSHIP" = "Membership",
  "SPONSORSHIP" = "Parrainage",
  "BIRTHDAY" = "Anniversaire",
}
export enum AccountSectionEnumEn {
  "PROGRAMMATION" = "Programmation",
  "AGENDA" = "Agenda",
  "MEMBERSHIP" = "Membership",
  "SPONSORSHIP" = "Sponsorship",
  "BIRTHDAY" = "Birthday",
}
